module.exports = __webpack_public_path__ + "img/MerloLogoLight.82bf7c58.png";